import {
  axiosInstance,
  LOGIN_URL,
  TEACHER_LOGIN_URL,
  LOGOUT_URL,
  FORGOT_PASSWORD_URL,
  RESET_TOKEN_VERIFICATION_URL,
  RESET_PASSWORD_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

export const login = async (loginName, password, setError) => {
  try {
    const response = await axiosInstance.post(LOGIN_URL, {
      login_name: loginName,
      password: password,
    });
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    setError(
      error.response?.data?.error ||
        "Login failed. Please check your credentials.",
    );
    throw error;
  }
};

export const teacherLogin = async (secretKey, courseKey, batchId, setError) => {
  try {
    let url = `${TEACHER_LOGIN_URL}?secret_key=${secretKey}`;
    if (courseKey) url += `&course_key=${courseKey}`;
    if (batchId) url += `&batch_id=${batchId}`;

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Teacher Login error:", error);
    if (setError) {
      setError(
        error.response?.data?.error ||
          "Login failed. Please check your credentials.",
      );
    }
    throw error;
  }
};

export const logout = async () => {
  try {
    await axiosInstance.post(LOGOUT_URL);
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    Cookies.remove("accessToken");
    Cookies.remove("user");
    Cookies.remove("hasShownPendingPopup");
  }
};

export const getAccessToken = () => {
  return Cookies.get("accessToken");
};

export const setAccessToken = (token, rememberMe = false) => {
  if (rememberMe) {
    Cookies.set("accessToken", token, { expires: 7 });
    Cookies.set("rememberme", "true", { expires: 7 });
  } else {
    Cookies.set("accessToken", token);
    Cookies.remove("rememberme");
  }
};

export const isAuthenticated = () => {
  return !!getAccessToken();
};

export const forgotPasswordCall = async (email, url) => {
  try {
    const response = await axiosInstance.post(FORGOT_PASSWORD_URL, { email, url });
    return response.data;
  } catch (error) {
    console.error("Forgot password error:", error);
    throw error;
  }
};

export const resetTokenVerificationCall = async (reset_token) => {
  try {
    const response = await axiosInstance.post(RESET_TOKEN_VERIFICATION_URL, { reset_token });
    return response.data;
  } catch (error) {
    console.error("Reset token verification error:", error);
    throw error;
  }
};

export const resetPasswordCall = async (change_password_token, new_password) => {
  try {
    const response = await axiosInstance.post(RESET_PASSWORD_URL, { change_password_token, new_password });
    return response.data;
  } catch (error) {
    console.error("Reset password error:", error);
    throw error;
  }
};
